import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { LabeledOption } from '@e3dc-react/shell/Types/globalTypes'
import { DirectionType, DirectionTypes, PowerOptimizerType, PowerOptimizerTypes, StringCount, StringCounts } from '../types/photovoltaic'

interface PhotovoltaicLabeledOptions {
  stringCountOptions: LabeledOption<StringCount>[]
  powerOptimizerOptions: LabeledOption<PowerOptimizerType>[]
  directionOptions: LabeledOption<DirectionType>[]
}

/**
 * This hook provides labeled options for the photovoltaic select fields
 */
const useLabeledPhotovoltaicOptions = (): PhotovoltaicLabeledOptions => {
  const { t } = useCustomTranslation()

  const stringCountOptions: LabeledOption<StringCount>[] = [
    {
      label: t('installation-statement.photovoltaic.label.string-count.one'),
      value: StringCounts.One,
    },
    {
      label: t('installation-statement.photovoltaic.label.string-count.two'),
      value: StringCounts.Two,
    },
    {
      label: t('installation-statement.photovoltaic.label.string-count.three'),
      value: StringCounts.Three,
    },
  ]

  const powerOptimizerOptions: LabeledOption<PowerOptimizerType>[] = [
    {
      label: t('installation-statement.photovoltaic.label.power-optimizer.all'),
      value: PowerOptimizerTypes.All,
    },
    {
      label: t('installation-statement.photovoltaic.label.power-optimizer.partial'),
      value: PowerOptimizerTypes.Partial,
    },
    {
      label: t('installation-statement.photovoltaic.label.power-optimizer.none'),
      value: PowerOptimizerTypes.None,
    },
  ]

  const directionOptions: LabeledOption<DirectionType>[] = [
    {
      value: DirectionTypes.N,
      label: t('installation-statement.photovoltaic.label.north'),
    },
    {
      value: DirectionTypes.NE,
      label: t('installation-statement.photovoltaic.label.north-east'),
    },
    {
      value: DirectionTypes.E,
      label: t('installation-statement.photovoltaic.label.east'),
    },
    {
      value: DirectionTypes.SE,
      label: t('installation-statement.photovoltaic.label.south-east'),
    },
    {
      value: DirectionTypes.S,
      label: t('installation-statement.photovoltaic.label.south'),
    },
    {
      value: DirectionTypes.SW,
      label: t('installation-statement.photovoltaic.label.south-west'),
    },
    {
      value: DirectionTypes.W,
      label: t('installation-statement.photovoltaic.label.west'),
    },
    {
      value: DirectionTypes.NW,
      label: t('installation-statement.photovoltaic.label.north-west'),
    },
  ]

  return { stringCountOptions, powerOptimizerOptions, directionOptions }
}

export default useLabeledPhotovoltaicOptions
